module.exports = __webpack_public_path__ + "static/media/introduce_p2@2x.8003cf54.png";